import React from 'react';
import {
	Box,
	Card,
	CardActionArea,
	CardContent,
	Stack,
	Typography,
	useTheme,
} from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { surfaceCard } from '../../Shared/surfaceCard';

/**
 * Title block used inside MobileListCard - optional subtitle + trailing chevron.
 */
export const MobileListCardHeader = ({
	title,
	subtitle,
	showChevron = false,
	endAdornment = null,
}) => (
	<Stack
		direction="row"
		alignItems="flex-start"
		justifyContent="space-between"
		spacing={1}
	>
		<Box sx={{ minWidth: 0, flex: 1 }}>
			<Typography
				variant="subtitle1"
				fontWeight={700}
				sx={{ lineHeight: 1.3, wordBreak: 'break-word' }}
			>
				{title}
			</Typography>
			{subtitle ? (
				<Typography
					component="div"
					variant="body2"
					color="text.secondary"
					sx={{ mt: 0.25, wordBreak: 'break-word' }}
				>
					{subtitle}
				</Typography>
			) : null}
		</Box>
		{endAdornment}
		{showChevron ? (
			<ChevronRightIcon
				sx={{ color: 'text.disabled', mt: 0.25, flexShrink: 0 }}
				aria-hidden
			/>
		) : null}
	</Stack>
);

/**
 * Card shell for mobile data lists. Optional onClick makes the whole card tappable.
 */
const MobileListCard = ({ children, onClick, sx, contentSx, ...cardProps }) => {
	const theme = useTheme();
	const body = (
		<CardContent sx={{ p: 2, '&:last-child': { pb: 2 }, ...contentSx }}>
			{children}
		</CardContent>
	);

	return (
		<Card
			elevation={0}
			sx={{
				...surfaceCard(theme),
				...(onClick
					? {
							'&:hover': {
								borderColor: 'primary.main',
							},
						}
					: null),
				...sx,
			}}
			{...cardProps}
		>
			{onClick ? (
				<CardActionArea onClick={onClick} sx={{ alignItems: 'stretch' }}>
					{body}
				</CardActionArea>
			) : (
				body
			)}
		</Card>
	);
};

export default MobileListCard;
